import { createContext } from 'react';

import { UserDto } from '~modules/user/model';

interface AuthContextProps {
	user: UserDto | null;
	logout: () => void;
	isPending: boolean;
	error: boolean;
}

export const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);
